define(["exports", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "react-intl-universal", "../../molecules/DashboardButton", "../../", "../../utils", "./styles"], function (_exports, _objectWithoutPropertiesLoose2, _react, _reactIntlUniversal, _DashboardButton, _, _utils, _styles) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireWildcard(_react);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  var _excluded = ["i18n", "currentLocale", "acessos", "cliente", "funcionario", "feature_flags", "globalUrl", "logoffClick", "chatFetchLink", "chatRedirect", "hideHelp", "parseMoveToParams", "userNavigation", "hideHomeLink", "chatUrl", "chatRole", "shouldHideMenuItems"];

  var Header = function Header(_ref) {
    var i18n = _ref.i18n,
        currentLocale = _ref.currentLocale,
        acessos = _ref.acessos,
        cliente = _ref.cliente,
        funcionario = _ref.funcionario,
        feature_flags = _ref.feature_flags,
        globalUrl = _ref.globalUrl,
        logoffClick = _ref.logoffClick,
        chatFetchLink = _ref.chatFetchLink,
        chatRedirect = _ref.chatRedirect,
        hideHelp = _ref.hideHelp,
        parseMoveToParams = _ref.parseMoveToParams,
        userNavigation = _ref.userNavigation,
        hideHomeLink = _ref.hideHomeLink,
        chatUrl = _ref.chatUrl,
        chatRole = _ref.chatRole,
        shouldHideMenuItems = _ref.shouldHideMenuItems,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);

    var _useState = (0, _react.useState)(false),
        opened = _useState[0],
        setOpened = _useState[1];

    var _useState2 = (0, _react.useState)(false),
        i18nLoaded = _useState2[0],
        setI18nLoaded = _useState2[1];

    (0, _react.useEffect)(function () {
      var mounted = true;

      if (!i18nLoaded) {
        (0, _utils.initIntl)(i18n, currentLocale).then(function () {
          return setI18nLoaded(true);
        });
      }
    }, []);

    var toggleOpened = function toggleOpened() {
      setOpened(!opened);
    };

    return !i18nLoaded ? null : /*#__PURE__*/_react.default.createElement(_styles.HeaderStyled, rest, /*#__PURE__*/_react.default.createElement(_styles.Overlay, {
      active: opened,
      onClick: toggleOpened
    }), /*#__PURE__*/_react.default.createElement(_styles.HeaderContainer, {
      flex: true
    }, /*#__PURE__*/_react.default.createElement(_.NavigationLink, {
      to: "/",
      as: _.GlobalLink,
      globalUrl: globalUrl
    }, /*#__PURE__*/_react.default.createElement(_.Logo, null)), shouldHideMenuItems ? null : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.HamburguerButton, {
      onClick: toggleOpened
    }, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "menu"
    })), /*#__PURE__*/_react.default.createElement(_styles.NavigationWrapper, {
      rounded: false,
      active: opened
    }, /*#__PURE__*/_react.default.createElement(_styles.CloseButton, {
      onClick: toggleOpened
    }, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "x"
    })), /*#__PURE__*/_react.default.createElement(_.Navigation, {
      menu: acessos != null && acessos.itens_menu ? acessos == null ? void 0 : acessos.itens_menu : [],
      i18n: i18n,
      globalUrl: globalUrl,
      hideHomeLink: hideHomeLink
    }), feature_flags.includes('comunicador-vagas') && /*#__PURE__*/_react.default.createElement(_.ChatIcon, {
      user: funcionario == null ? void 0 : funcionario.id,
      company: cliente == null ? void 0 : cliente.id,
      url: chatUrl,
      role: chatRole
    }), feature_flags.includes('beamer-vagas') && /*#__PURE__*/_react.default.createElement(_.BeamerIcon, null), !hideHelp && /*#__PURE__*/_react.default.createElement(_styles.HelpButton, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "help-circle"
    })), /*#__PURE__*/_react.default.createElement(_styles.HeaderSeparator, null), userNavigation || /*#__PURE__*/_react.default.createElement(_.NavigationUser, {
      acessos: acessos != null && acessos.itens_menu_usuario ? acessos == null ? void 0 : acessos.itens_menu_usuario : [],
      i18n: i18n,
      funcionario: funcionario,
      globalUrl: globalUrl,
      logoffClick: logoffClick,
      parseMoveToParams: parseMoveToParams
    }), /*#__PURE__*/_react.default.createElement(_styles.LogoffButton, null, /*#__PURE__*/_react.default.createElement(_.Button, {
      as: "a",
      href: (0, _utils.moveToParams)('finalizar-sessao'),
      globalUrl: globalUrl,
      title: _reactIntlUniversal.default.get('NAVEGACAO_USUARIO.LOGOFF'),
      outline: true,
      onClick: function onClick(e) {
        logoffClick(e);
      },
      kind: "cancel"
    }, _reactIntlUniversal.default.get('NAVEGACAO_USUARIO.LOGOFF'))), /*#__PURE__*/_react.default.createElement(_DashboardButton.DashboardButton, {
      globalUrl: globalUrl
    })))));
  };

  Header.defaultProps = {
    logoffClick: function logoffClick() {},
    parseMoveToParams: true,
    i18n: {},
    acessos: {},
    cliente: {},
    funcionario: {},
    feature_flags: [],
    hideHomeLink: false,
    chatRole: 'empresas'
  };
  var _default = Header;
  _exports.default = _default;
});